import { IconButton, Tooltip, useTheme } from '@chakra-ui/react';
import { IconButtonContainer } from '../appShared';
import { DownloadIcon } from '../icons';
import { useGlobalState } from '../hooks/useGlobalState';

interface DownloadButtonProps {
  downloadCSV: () => void;
}

export const DownloadButton = ({ downloadCSV }: DownloadButtonProps) => {
  const { colors } = useTheme();
  const { globalState } = useGlobalState();
  const downloadAllowed = globalState?.dto?.downloadAllowed;

  return (
    <Tooltip
      hasArrow
      placement="bottom-end"
      label={
        downloadAllowed ? 'Download Data' : 'Upgrade plan to download data'
      }
    >
      <IconButton
        bg="transparent"
        border="1px solid #E0E0E0"
        borderRadius="4px"
        aria-label="circle"
        size="sm"
        disabled={!downloadAllowed}
        onClick={downloadCSV}
        icon={
          <DownloadIcon
            height="16px"
            width="16px"
            color={colors.text.secondary}
          />
        }
      />
    </Tooltip>
  );
};

export default DownloadButton;
